import axios from './axiosWrapper';
import { getDashboardSessionId } from '../utils/dashboardAuth';

const Login = {
    sendOtp(email) {
        return axios.post('/auth/send-otp', {
            email: email,
        }, {
            withCredentials: true
        })
    },
    validateOtp(email, otp) {
        return axios.post('/auth/validate-otp', {
            email: email,
            otp
        }, {
            withCredentials: true,
            headers: {
                "Content-Type": "application/json",
                "heydu-session-id": getDashboardSessionId(),
            },
        })
    }
}
export default Login;